/* TICHO product lightbox: one media item, keyboard/swipe navigation and thumbs. */
if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.currentIndex = 0;
      this.touchStartX = null;
      this.querySelector('.ticho-gallery__arrow--prev')?.addEventListener('click', () => this.navigate(-1));
      this.querySelector('.ticho-gallery__arrow--next')?.addEventListener('click', () => this.navigate(1));
      this.querySelectorAll('.ticho-gallery__thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const i = this.items.findIndex(item => item.dataset.mediaId === thumb.dataset.targetMediaId);
          if (i !== -1) this.activate(i);
        });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.navigate(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.navigate(-1); }
      });
      const area = this.querySelector('.product-media-modal__content');
      area?.addEventListener('touchstart', (e) => { this.touchStartX = e.changedTouches[0]?.screenX ?? null; }, {passive: true});
      area?.addEventListener('touchend', (e) => {
        if (this.touchStartX === null) return;
        const delta = (e.changedTouches[0]?.screenX ?? this.touchStartX) - this.touchStartX;
        this.touchStartX = null;
        if (Math.abs(delta) > 55) this.navigate(delta < 0 ? 1 : -1);
      }, {passive: true});
    }
    get allItems() {
      return Array.from(this.querySelector('.product-media-modal__content')?.children || [])
        .filter(item => item.hasAttribute('data-media-id'));
    }
    get items() { return this.allItems.filter(item => !item.hidden); }
    syncVariantMedia() {
      const section = this.closest('.shopify-section') || document;
      const gallery = section.querySelector('media-gallery[data-ticho-active-sku]') ||
        section.querySelector('media-gallery');
      if (!gallery) return;

      // The existing product-card SKU filter is the source of truth.
      // Use its CURRENT variant; never infer a SKU from the modal's full collection.
      let sku = gallery.dataset.tichoActiveSku || '';
      const json = gallery.querySelector('[data-ticho-variant-gallery-data]');
      if (json) {
        try {
          const data = JSON.parse(json.textContent);
          const variantId = section.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
            new URL(location.href).searchParams.get('variant') || data.selectedVariantId;
          const variant = data.variants.find(v => String(v.id) === String(variantId));
          if (variant?.sku) sku = variant.sku.toUpperCase();
        } catch (_) { /* Leave the last active SKU unchanged. */ }
      }
      // Prefer the exact visible media IDs produced by the product-page filter.
      // Fallback to the same SKU matcher if data has not yet been initialized.
      let allowed = null;
      try {
        const ids = JSON.parse(gallery.dataset.tichoVisibleMediaIds || 'null');
        if (Array.isArray(ids) && ids.length) allowed = new Set(ids.map(String));
      } catch (_) { /* use SKU matcher */ }
      if (!allowed && (!/^SL\d{4}$/i.test(sku) || typeof window.tichoMediaBelongsToSku !== 'function')) return;

      const matching = new Set();
      this.allItems.forEach(item => {
        const mediaId = String(item.dataset.mediaId || '').split('-').pop();
        const visible = allowed ? allowed.has(mediaId) : window.tichoMediaBelongsToSku(item, sku);
        item.hidden = !visible;
        item.style.display = visible ? '' : 'none';
        item.setAttribute('aria-hidden', String(!visible));
        if (visible) matching.add(String(item.dataset.mediaId).split('-').pop());
        else item.classList.remove('active');
      });
      this.querySelectorAll('.ticho-gallery__thumb').forEach(thumb => {
        const visible = matching.has(String(thumb.dataset.targetMediaId).split('-').pop());
        thumb.hidden = !visible;
        thumb.style.display = visible ? '' : 'none';
      });
    }
    show(opener) {
      this.syncVariantMedia();
      super.show(opener);
      const id = opener?.getAttribute('data-media-id');
      const index = this.items.findIndex(item => item.dataset.mediaId === id);
      this.activate(index >= 0 ? index : 0);
    }
    navigate(direction) {
      if (this.items.length < 2) return;
      this.activate((this.currentIndex + direction + this.items.length) % this.items.length);
    }
    activate(index) {
      const items = this.items;
      if (!items.length) return;
      this.currentIndex = Math.max(0, Math.min(index, items.length - 1));
      items.forEach((item, i) => {
        const selected = i === this.currentIndex;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-hidden', String(!selected));
        if (!selected) {
          item.querySelectorAll('video').forEach(video => video.pause());
          item.querySelectorAll('iframe').forEach(frame => { if (frame.src) frame.src = frame.src; });
        }
      });
      const current = items[this.currentIndex];
      const count = this.querySelector('.ticho-gallery__count');
      if (count) count.textContent = `${this.currentIndex + 1} / ${items.length}`;
      this.querySelectorAll('.ticho-gallery__thumb').forEach(thumb => {
        const selected = thumb.dataset.targetMediaId === current.dataset.mediaId;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-pressed', String(selected));
        if (selected) thumb.scrollIntoView({block: 'nearest', inline: 'nearest'});
      });
      this.querySelectorAll('.ticho-gallery__arrow').forEach(button => button.hidden = items.length < 2);
      if (current.matches('deferred-media') && current.querySelector('template .js-youtube')) current.loadContent();
    }
  });
}
